export function getCookie(name: string): string {
  const cookie = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop();
  return cookie ?? "";
}

export function setCookie(name: string, value: string): void {
  document.cookie = `${name}=${value};path=/;`;
}
